import {
  Button,
  Col,
  Divider,
  Icon,
  Input,
  Modal,
  Row,
  Select,
  Spin,
  Table,
  Tabs,
  Card,
  Checkbox
} from 'antd';
import {
  CheckOutlined,
  StockOutlined,
  TeamOutlined,
  DashboardFilled,
  SettingOutlined,
  ToolFilled,
  PoweroffOutlined,
  InfoCircleOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  UserOutlined,
  VideoCameraOutlined,
  HomeOutlined,
  CarOutlined,
  UploadOutlined,
  RocketFilled,
  ShopFilled,
  TagsFilled,
  ReadFilled,
  QuestionCircleOutlined,
  SearchOutlined,
  PlusOutlined,
  PlusCircleFilled,
  EditFilled,
  DeleteFilled
} from '@ant-design/icons';
import { Form } from '@ant-design/compatible';
import React from 'react';
import Highlighter from 'react-highlight-words';
import Notify from '../../meta/Notification';
import styled from 'styled-components';
import { regExpLiteral } from '@babel/types';
import UserEditSVG from 'src/static/user-edit-icon.svg';
import BellIconSVG from 'src/static/bell-icon.svg';
import DeleteSVG from 'src/static/delete-icon.svg';
import UserAddedIconSVG from 'src/static/user-added-icon.svg';
import { connect } from 'react-redux';
import { getSidebarCollapsed, getUser } from 'src/redux/selectors';

// import "react-responsive-modal/styles.css";
// import { Modal as SuccessModal } from "react-responsive-modal";
const { Column, ColumnGroup } = Table;
const FormItem = Form.Item;
const { TextArea } = Input;
const Option = Select.Option;
const numeral = require('numeral');
const { TabPane } = Tabs;

const StyledTable = styled(Table)`
  // .ant-table-thead > tr > th {
  //   text-align: center !important;
  // }
`;
const Selection = styled(Select)`
  .ant-select-selection {
    border: 1px solid #bdb2b2;
    height: 45px;
    font-size: 12px;
  }
  .ant-select-selection__placeholder {
    top: 21px;
  }
  .ant-select-selection__rendered {
    height: 44px;
  }
  .ant-select-selection-selected-value {
    position: relative;
    top: 6px;
  }
`;
function handleChange(value) {
  console.log(`selected ${value}`);
}
class UserFormClass extends React.Component {
  handleSiteChange = value => {
    // Retrieve the selected site based on its ID
    const selectedSite = this.props.sites.find(site => site._id === value);

    // Set the company currency to the selected site's currency
    if (selectedSite) {
      this.props.form.setFieldsValue({
        companyCurrency: selectedSite.companyCurrency || '', // Set the company currency
        companyProfitMargin: selectedSite.companyProfitMargin || ''
      });
    }
  };

  render() {
    return (
      <Form layout="vertical">
        <Row gutter={24} style={{ marginBottom: '3em' }}>
          <Col span={12} style={{ marginTop: '1.5em' }}>
            <FormItem label={<span>Name & Surname</span>}>
              {this.props.form.getFieldDecorator('name', {
                rules: [
                  { required: true, message: 'User full name required' },
                  {
                    pattern: RegExp(
                      /^([a-zA-Z]{2,}\s[a-zA-z]{1,}'?-?[a-zA-Z]{2,}\s?([a-zA-Z]{1,})?)/
                    ),
                    message: 'A name and surname is required'
                  }
                ],
                initialValue: this.props.editUser
                  ? this.props.editUser.name
                  : ''
              })(<Input />)}
            </FormItem>
          </Col>
          <Col span={12} style={{ marginTop: '1.5em' }}>
            <FormItem label={<span>Number</span>}>
              {this.props.form.getFieldDecorator('number', {
                rules: [
                  { required: true, message: 'User number required' },
                  {
                    pattern: RegExp(/\d/g),
                    message: 'A valid number is required'
                  }
                ],
                initialValue: this.props.editUser
                  ? this.props.editUser.number
                  : ''
              })(<Input />)}
            </FormItem>
          </Col>

          <Col span={12} style={{ marginTop: '1.5em' }}>
            <FormItem label={<span>Email</span>}>
              {this.props.form.getFieldDecorator('email', {
                rules: [
                  {
                    required: true,
                    message: 'Email address is required.'
                  },
                  {
                    type: 'email',
                    message: 'A valid email is required.'
                  }
                ],
                initialValue: this.props.editUser
                  ? this.props.editUser.email
                  : ''
              })(<Input />)}
            </FormItem>
          </Col>
          <Col span={12} style={{ marginTop: '1.5em' }}>
            <Form.Item label={<span>Company Access</span>}>
              {this.props.form.getFieldDecorator('access', {
                rules: [{ required: false, message: 'Access required' }],
                initialValue: this.props.editUser
                  ? this.props.editUser.access
                  : []
              })(
                <Select onChange={this.handleSiteChange}>
                  {this.props.sites
                    .filter(site => this.props.access.includes(site._id))
                    .map(site => (
                      <Option key={site._id} value={site._id}>
                        {site.name}
                      </Option>
                    ))}
                </Select>
              )}
            </Form.Item>
          </Col>
          {/* <Col span={12}>
            <Form.Item style={{}} label={<span>Currency</span>}>
              {this.props.form.getFieldDecorator('companyCurrency', {
                rules: [{ required: false, message: 'Tags required' }],
                initialValue: this.props.editUser
                  ? this.props.editUser.companyCurrency
                  : ''
              })(
                <Select style={{ width: '100%' }}>
                  <Option value="R">R (South Africa)</Option>
                  <Option value="Ksh">Ksh (Kenya)</Option>
                  <Option value="TZS">TZS (Tanzanian)</Option>
                  <Option value="USD">USD (Dollar)</Option>
                </Select>
              )}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item style={{}} label={<span>Profit Margin</span>}>
              {this.props.form.getFieldDecorator('companyProfitMargin', {
                rules: [{ required: false, message: 'Tags required' }],
                initialValue: this.props.editUser
                  ? this.props.editUser.companyProfitMargin
                  : ''
              })(
                <Input
                  suffix="%"
                  // placeholder="Profit Margin"
                  defaultValue={0}
                  style={{ width: '100%' }}
                />
              )}
            </Form.Item>
          </Col> */}

          {/* <Col span={12}>
            <FormItem label={<span>Department</span>}>
              {this.props.form.getFieldDecorator("department", {
                rules: [{ required: true, message: "Department is required" }],
                initialValue: this.props.editUser
                  ? this.props.editUser.department
                  : "Office",
              })(
                <Select
                  mode="tags"
                  style={{ width: "100%" }}
                  onChange={handleChange}
                  tokenSeparators={[","]}
                >
                  <Option value="Kitchen">Kitchen</Option>
                  <Option value="Office">Office</Option>
                  <Option value="Cleaning Crew">Cleaning Crew</Option>
                </Select>
              )}
            </FormItem>
          </Col> */}

          {/* <FormItem label={"Roles Stock"}>
          {this.props.form.getFieldDecorator("isAdd", {
            valuePropName: "checked",
            initialValue: this.props.editUser
              ? this.props.editUser.isAdd
                ? true
                : false
              : false,
          })(<Checkbox>Add Stock</Checkbox>)}
          {this.props.form.getFieldDecorator("isEdit", {
            valuePropName: "checked",
            initialValue: this.props.editUser
              ? this.props.editUser.isEdit
                ? true
                : false
              : false,
          })(<Checkbox>Edit Stock</Checkbox>)}
          {this.props.form.getFieldDecorator("isDelete", {
            valuePropName: "checked",
            initialValue: this.props.editUser
              ? this.props.editUser.isDelete
                ? true
                : false
              : false,
          })(<Checkbox>Delete Stock</Checkbox>)}

        </FormItem>
        <FormItem>
          {this.props.form.getFieldDecorator("isStockOut", {
            valuePropName: "checked",
            initialValue: this.props.editUser
              ? this.props.editUser.isStockOut
                ? true
                : false
              : false,
          })(<Checkbox>Submit Stock Out</Checkbox>)}
        </FormItem> */}
          {/* <FormItem label={'Roles PEX'}>
          {this.props.form.getFieldDecorator('isPexAdd', {
            valuePropName: 'checked',
            initialValue: this.props.editUser
              ? this.props.editUser.isPexAdd
                ? true
                : false
              : false
          })(<Checkbox>Add Stock</Checkbox>)}
          {this.props.form.getFieldDecorator('isPexEdit', {
            valuePropName: 'checked',
            initialValue: this.props.editUser
              ? this.props.editUser.isPexEdit
                ? true
                : false
              : false
          })(<Checkbox>Edit Stock</Checkbox>)}
          {this.props.form.getFieldDecorator('isPexDelete', {
            valuePropName: 'checked',
            initialValue: this.props.editUser
              ? this.props.editUser.isPexDelete
                ? true
                : false
              : false
          })(<Checkbox>Delete Stock</Checkbox>)}
        </FormItem>
        <FormItem>
          {this.props.form.getFieldDecorator('isPexOut', {
            valuePropName: 'checked',
            initialValue: this.props.editUser
              ? this.props.editUser.isPexOut
                ? true
                : false
              : false
          })(<Checkbox>PEX Unit Out</Checkbox>)}
        </FormItem> */}
        </Row>
      </Form>
    );
  }
}
const UserForm = Form.create()(UserFormClass);
class ManagerFormClass extends React.Component {
  render() {
    return (
      <Form layout="vertical">
        <Row gutter={24} style={{ marginBottom: '3em' }}>
          <Col span={12} style={{ marginTop: '1.5em' }}>
            <FormItem label={<span>Name & Surname</span>}>
              {this.props.form.getFieldDecorator('name', {
                rules: [
                  { required: true, message: 'User full name required' },
                  {
                    pattern: RegExp(
                      /^([a-zA-Z]{2,}\s[a-zA-z]{1,}'?-?[a-zA-Z]{2,}\s?([a-zA-Z]{1,})?)/
                    ),
                    message: 'A name and surname is required'
                  }
                ],
                initialValue: this.props.editManager
                  ? this.props.editManager.name
                  : ''
              })(<Input />)}
            </FormItem>
          </Col>
          <Col span={12} style={{ marginTop: '1.5em' }}>
            <FormItem label={<span>Number</span>}>
              {this.props.form.getFieldDecorator('number', {
                rules: [
                  { required: true, message: 'User number required' },
                  {
                    pattern: RegExp(/\d/g),
                    message: 'A valid number is required'
                  }
                ],
                initialValue: this.props.editManager
                  ? this.props.editManager.number
                  : ''
              })(<Input />)}
            </FormItem>
          </Col>
          <Col span={12} style={{ marginTop: '1.5em' }}>
            <FormItem label={<span>Email</span>}>
              {this.props.form.getFieldDecorator('email', {
                rules: [
                  {
                    required: true,
                    message: 'Email address is required.'
                  },
                  {
                    type: 'email',
                    message: 'A valid email is required.'
                  }
                ],
                initialValue: this.props.editManager
                  ? this.props.editManager.email
                  : ''
              })(<Input />)}
            </FormItem>
          </Col>
          <Col span={12} style={{ marginTop: '1.5em' }}>
            <FormItem label={<span>Company Access</span>}>
              {this.props.form.getFieldDecorator('access', {
                rules: [
                  {
                    required: false,
                    message: 'Access required'
                  }
                ],
                initialValue: this.props.editManager
                  ? this.props.editManager.access
                  : []
              })(
                // <Select mode="multiple">
                <Select
                // mode="multiple"
                >
                  {this.props.sites.map(site => (
                    <Option key={site._id} value={site._id}>
                      {site.name}
                    </Option>
                  ))}
                </Select>
              )}
            </FormItem>
          </Col>
          {/* <Col span={12}>
            <FormItem label={<span>Department</span>}>
              {this.props.form.getFieldDecorator("department", {
                rules: [{ required: true, message: "Department is required" }],
                initialValue: this.props.editManager
                  ? this.props.editManager.department
                  : "Office",
              })(
                <Select
                  mode="tags"
                  style={{ width: "100%" }}
                  onChange={handleChange}
                  tokenSeparators={[","]}
                >
                  <Option value="Kitchen">Kitchen</Option>
                  <Option value="Office">Office</Option>
                  <Option value="Cleaning Crew">Cleaning Crew</Option>
                </Select>
              )}
            </FormItem>
          </Col> */}
        </Row>
      </Form>
    );
  }
}
const ManagerForm = Form.create()(ManagerFormClass);
class BuyerFormClass extends React.Component {
  handleSiteChange = value => {
    // Retrieve the selected site based on its ID
    const selectedSite = this.props.sites.find(site => site._id === value);

    // Set the company currency to the selected site's currency
    if (selectedSite) {
      this.props.form.setFieldsValue({
        companyCurrency: selectedSite.companyCurrency || '', // Set the company currency
        companyProfitMargin: selectedSite.companyProfitMargin || ''
      });
    }
  };
  render() {
    return (
      <Form layout="vertical">
        <Col span={24} style={{ marginTop: '2em' }}>
          <FormItem label={<span>Name & Surname</span>}>
            {this.props.form.getFieldDecorator('name', {
              rules: [
                { required: true, message: 'Buyer full name required' },
                {
                  pattern: RegExp(
                    /^([a-zA-Z]{2,}\s[a-zA-z]{1,}'?-?[a-zA-Z]{2,}\s?([a-zA-Z]{1,})?)/
                  ),
                  message: 'A name and surname is required'
                }
              ],
              initialValue: this.props.editBuyer
                ? this.props.editBuyer.name
                : ''
            })(<Input />)}
          </FormItem>
        </Col>
        {/* <FormItem label={<span>Number</span>}>
          {this.props.form.getFieldDecorator("number", {
            rules: [
              { required: true, message: "Buyer number required" },
              {
                pattern: RegExp(/\d/g),
                message: "A valid number is required",
              },
            ],
            initialValue: this.props.editBuyer
              ? this.props.editBuyer.number
              : "",
          })(<Input  />)}
        </FormItem> */}
        <Col span={24} style={{ marginTop: '1em' }}>
          <FormItem label={<span>Email</span>}>
            {this.props.form.getFieldDecorator('email', {
              rules: [
                {
                  required: true,
                  message: 'Email address is required.'
                },
                {
                  type: 'email',
                  message: 'A valid email is required.'
                }
              ],
              initialValue: this.props.editBuyer
                ? this.props.editBuyer.email
                : ''
            })(<Input />)}
          </FormItem>
        </Col>
        <Col span={24} style={{ marginTop: '1em', marginBottom: '3em' }}>
          <Form.Item label={<span>Company Access</span>}>
            {this.props.form.getFieldDecorator('access', {
              rules: [{ required: false, message: 'Access required' }],
              initialValue: this.props.editBuyer
                ? this.props.editBuyer.access
                : []
            })(
              <Select onChange={this.handleSiteChange}>
                {this.props.sites.map(site => (
                  <Option key={site._id} value={site._id}>
                    {site.name}
                  </Option>
                ))}
              </Select>
            )}
          </Form.Item>
        </Col>
        {/* <Form.Item style={{}} label={<span>Currency</span>}>
          {this.props.form.getFieldDecorator('companyCurrency', {
            rules: [{ required: false, message: 'Tags required' }],
            initialValue: this.props.editBuyer
              ? this.props.editBuyer.companyCurrency
              : ''
          })(
            <Select
              // disabled={this.props.editUser ? true : false}
              style={{ width: '100%' }}
            >
              <Option value="R">R (South Africa)</Option>
              <Option value="Ksh">Ksh (Kenya)</Option>
            </Select>
          )}
        </Form.Item>
        <Form.Item style={{}} label={<span>Profit Margin</span>}>
          {this.props.form.getFieldDecorator('companyProfitMargin', {
            rules: [{ required: false, message: 'Tags required' }],
            initialValue: this.props.editBuyer
              ? this.props.editBuyer.companyProfitMargin
              : ''
          })(
            <Input
              suffix="%"
              // placeholder="Profit Margin"
              // defaultValue={0}
              style={{ width: '100%' }}
            />
          )}
        </Form.Item> */}
      </Form>
    );
  }
}
function info() {
  Modal.info({
    title: 'This is a notification message',
    content: (
      <div>
        <img src={UserAddedIconSVG} style={{ width: '13em' }} />
        <h1
          style={{
            fontSize: '22px',
            lineHeight: '1.1em',
            paddingRight: '0.4em',
            paddingTop: '0.1em',
            fontWeight: 700,
            color: '#535152'
          }}
        >
          User Added Successfully
        </h1>
        {/* <p>
          An Email will be sent to the user with a link to <br /> create a
          password and enter the system.
        </p> */}
      </div>
    ),
    onOk() {}
  });
}

function success() {
  Modal.success({
    Icon: <QuestionCircleOutlined style={{ display: 'none' }} />,
    okText: 'Done',
    content: (
      <div style={{ textAlign: 'center' }}>
        <img
          src={UserAddedIconSVG}
          style={{ width: '6em', marginBottom: '2em' }}
        />
        <h1
          style={{
            fontSize: '22px',
            lineHeight: '1.1em',
            paddingRight: '0.4em',
            paddingTop: '0.1em',
            fontWeight: 700,
            color: '#535152'
          }}
        >
          User Added Successfully
        </h1>
        {/* <p>
          An Email will be sent to the user with a link to <br /> create a
          password and enter the system.
        </p> */}
      </div>
    )
  });
}

function error() {
  Modal.error({
    title: 'This is an error message',
    content: 'some messages...some messages...'
  });
}

function warning() {
  Modal.warning({
    title: 'This is a warning message',
    content: 'some messages...some messages...'
  });
}
const BuyerForm = Form.create()(BuyerFormClass);
class Users extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      closed: false,
      rejectReason: '',
      editDealer: undefined,
      editManager: undefined,
      editUser: undefined,
      activeTabKey: '2',
      siteSelected: null,

      successModal: false
    };
    this.onFinish = this.onFinish.bind(this);
  }
  handleSubmit = values => {
    this.onFinish(values);
  };
  handleCloseSuccessModal = () => {
    this.setState({ successModal: false });
    // window.location.assign("./");
  };
  onFinish = values => {
    const MSG = {
      // to: this.props.editUser ? this.props.editUser.email : "",
      // this.props.editUser.name
      from: 'noreply@smartsprout.online.co.za',
      to: values.email,
      subject: 'Profile Activation',
      text: ' ',
      html: `
          
      <style type="text/css">
      body, #bodyTable{background - color:white}
      #emailHeader{background - color:white}
      #emailBody{background - color:#FFFFFF; border:1px solid #CCCCCC;}
      #emailFooter{background - color:#E1E1E1;}
    </style>
    <body bgcolor="#E1E1E1" leftmargin="0" marginwidth="0" topmargin="0" marginheight="0" offset="0">
      <center style="background-color:#E1E1E1;">
        <table border="0" cellpadding="0" cellspacing="0" height="100%" width="100%" id="bodyTable" style="table-layout: fixed;max-width:100% !important;width: 100% !important;min-width: 100% !important;">
          <tr>
            <td align="center" valign="top" id="bodyCell">
              <table bgcolor="#E1E1E1" border="0" cellpadding="0" cellspacing="0" width="500" id="emailHeader">
                <!-- HEADER ROW // -->
                <tr>
                  <td align="center" valign="top">
                    <!-- CENTERING TABLE // -->
                    <table border="0" cellpadding="0" cellspacing="0" width="100%">
                      <tr>
                        <td align="center" valign="top">
                          <!-- FLEXIBLE CONTAINER // -->
                          <table border="0" cellpadding="10" cellspacing="0" width="500" class="flexibleContainer">
                            <tr>
                              <td valign="top" width="500" class="flexibleContainerCell">

                                <!-- CONTENT TABLE // -->
                                <table align="left" border="0" cellpadding="0" cellspacing="0" width="100%">
                                  <tr>

                                    <td align="right" valign="middle" class="flexibleContainerBox">
                                      <table border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:100%;">
                                        <tr>
                                          <td align="left" class="textContent">
                                            <!-- CONTENT // -->

                                          </td>
                                        </tr>
                                      </table>
                                    </td>
                                  </tr>
                                </table>
                              </td>
                            </tr>
                          </table>
                          <!-- // FLEXIBLE CONTAINER -->
                        </td>
                      </tr>
                    </table>
                    <!-- // CENTERING TABLE -->
                  </td>
                </tr>
                <!-- // END -->
              </table>
              <!-- EMAIL BODY // -->
              <table bgcolor="#FFFFFF" border="0" cellpadding="0" cellspacing="0" width="500"style="padding-bottom:3em;" id="emailBody">
                <!-- MODULE ROW // -->
                <tr>
                  <td align="center" valign="top">
                    <!-- CENTERING TABLE // -->
                    <table border="0" cellpadding="0" cellspacing="0" style="color:#FFFFFF;" bgcolor="white">
                      <tr>
                        <td align="center" valign="top">
                          <!-- FLEXIBLE CONTAINER // -->

                          <table border="0" cellpadding="0" cellspacing="0" width="500" class="flexibleContainer">
                            <tr>
                              <td align="center" valign="top" width="500" class="flexibleContainerCell">

                                <!-- CONTENT TABLE // -->

                                <table border="0" cellpadding="0" cellspacing="0" width="100%" z-index="100" >
                                  <td align="center" valign="top" width="500"  class="flexibleContainerCell  ">
                                    <img alt="" src="https://i.ibb.co/Brf5g6F/Screenshot-2023-10-26-122539.png" width="300" height="150" style="display: block; width:158px; max-width: 250px;; min-width: 189px;;border-radius: 8px 8px 8px 8px; font-family: Lato, Helvetica, Arial, sans-serif; color: #9AA31E; font-size: 18px;margin-top: 18px;" border="0">     <tr>
                                      <td align="center" valign="top" class="textContent">
                                      <h1 style="color:black;line-height:100%;font-family:Helvetica,Arial,sans-serif;font-size:28px;font-weight:600;margin-bottom:0px;margin-top:20px;text-align:center;">You have been invited by ${
                                        this.props.user.name
                                      } to join Smart<span style="color:#7CE495;"> Sprout</span>
                                        <h2 style="text-align:center;font-weight:normal;font-family:Helvetica,Arial,sans-serif;font-size:17px;margin-bottom:10px;color:black;line-height:135%;">
Click the link and follow the steps to activate<br />
and set up account. <br /><br /><strong>Your profile email:</strong><br />
                                      
                                        
                                        ${values.email}<br /><br />
                                        <strong>Temporary Password:</strong><br />
                                        1234

    <br /><br /><a style="padding: 10px;
margin-right: 15px;
font-size: 17px;
font-weight: 500;
border-radius: 3em;
color: #fff;
background-color: #7CE495;
border-color: #7CE495;" href="https://www.smartsprout.online/" target="_blank">Activate Account
</a><br /><br />  For troubleshooting or queries <a href="https://sprout360.africa/">ask us here</a></h2>
                                      </td>
                                    </tr>
                                    </table>
                                    <!-- // CONTENT TABLE -->
                                  </td>
                                </tr>
                              </table>
                              <!-- // FLEXIBLE CONTAINER -->
                            </td>
                          </tr>
                        </table>
                        <!-- // CENTERING TABLE -->
                      </td>
                    </tr>
                    <!-- MODULE ROW // -->
                
                        <!-- // MODULE ROW -->


                        <!-- MODULE ROW // -->

                      
                              <!-- // FLEXIBLE CONTAINER -->
                            </td>
                          </tr>
                        </table>
                                  `
    };
    fetch('https://www.vcsappcloud.com/emailclient/sendmail', {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json; charset=utf-8'
      },
      body: JSON.stringify(MSG)
    }).then(async res => {
      if (!res.ok) {
        console.log('handle error');
      }
      console.log('handle success');
      this.setState({
        // successModal: true,
        // submitDisabled: true,
        name: '',
        email: '',
        number: '',
        message: ''
      });
    });
  };
  componentWillMount = () => {
    this.setState({ loading: true });
    this.props
      .findAllUsers()
      // .then(() => {
      //   this.props
      //     .findAllManagers()
      // .then(() => {
      //   this.props
      //     .findAllBuyers()
      .then(() => {
        this.props
          .findAllSites()
          .then(() => {
            this.setState({ loading: false });
          })
          .catch(e => {
            this.setState({ loading: false });
            Notify('error', e);
          });
      })
      //     .catch(e => {
      //       this.setState({ loading: false });
      //       Notify('error', e);
      //     });
      // })
      // .catch(e => {
      //   this.setState({ loading: false });
      //   Notify('error', e);
      // });
      // })
      .catch(e => {
        this.setState({ loading: false });
        Notify('error', e);
      });
    window.addEventListener('resize', this.resizeEvent);
    if (window.cordova) {
      document.addEventListener('backbutton', this.handleBack);
    }
  };

  handleBack = () => {
    if (this.state.addUserVisible) {
      this.setState({ addUserVisible: false });
    } else {
      // Replace '/admin/reporting' with your desired initial route
      const initialRoute = '/admin/reporting';
      const { history } = this.props;

      // Check if there's a stored route in localStorage
      const storedRoute = localStorage.getItem('storedRoute');

      // Use the stored route or the initial route when going back
      history.push(storedRoute || initialRoute);
    }
  };

  componentWillUnmount = () => {
    window.removeEventListener('resize', this.resizeEvent);
    if (window.cordova) {
      document.removeEventListener('backbutton', this.handleBack);
    }
  };

  resizeEvent = () => {
    this.setState({ loading: false });
  };
  stopProp = e => {
    e.stopPropagation();
  };

  handleSelectUser = e => {
    this.props.setUserDetailsId(e.currentTarget.getAttribute('data'));
    this.props.push('/admin/userdetails');
  };
  handleSort = (pagination, filters, sorter) => {
    const columnKey = sorter.columnKey;
    const order = sorter.order;
    let users = this.props.users;
    if (order === 'ascend') {
      users.sort((a, b) => parseInt(a[columnKey]) - parseInt(b[columnKey]));
    } else if (order === 'descend') {
      users.sort((a, b) => parseInt(b[columnKey]) - parseInt(a[columnKey]));
    }
  };
  handleSearch = (selectedKeys, confirm) => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  };

  handleReset = clearFilters => {
    clearFilters();
    this.setState({ searchText: '' });
  };
  handleChange = (pagination, filters, sorter) => {
    console.log('Various parameters', pagination, sorter);
    this.setState({
      sortedInfo: sorter
    });
  };
  getColumnSearchProps = dataIndex => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={`Search`}
          value={selectedKeys[0]}
          onChange={e =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm)}
          // icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: text =>
      text ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        ''
      )
  });
  userForm;

  onAddUser = e => {
    this.setState({ addUserVisible: true, editUser: undefined });
  };

  handleAddUser = e => {
    e.preventDefault();
    this.userForm.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        if (!this.state.editUser) {
          // Execute only if editUser is false
          // this.onFinish(values); // Call onFinish when not editing user
        }
        this.setState({ loading: true });
        if (this.state.editUser) {
          values._id = this.state.editUser._id;
        } else {
          values.type = 'user';
          values.password = 'pass';
          values.firstLogin = true;
        }
        values.manager = [values.manager];
        this.props
          .addUser(values)
          .then(() => {
            this.props
              .findAllUsers()
              .then(() => {
                if (this.state.editUser) {
                  Notify('success', 'Successfully saved user'); // You can replace info() with Notify("success", "Successfully saved user");
                } else {
                  success(); // You can replace success() with Notify("success", "Successfully added user");
                }
                this.userForm.props.form.resetFields();
                this.setState({
                  loading: false,
                  addUserVisible: false,
                  editUser: undefined
                });
              })
              .catch(e => {
                this.setState({ loading: false });
                Notify('error', e);
              });
          })
          .catch(e => {
            this.setState({ loading: false });
            Notify('error', e);
          });
      }
    });
  };
  handleEditUser = e => {
    this.setState({ addUserVisible: true, editUser: e });
  };
  handleDeleteUser = e => {
    const id = e.currentTarget.getAttribute('data');
    var that = this;
    Modal.confirm({
      centered: true,
      content: (
        <div>
          <h4>Are your sure you want to delete this user?</h4>
        </div>
      ),
      onOk() {
        that.setState({ loading: true });
        that.props
          .deleteUser(id)
          .then(() => {
            that.props
              .findAllUsers()
              .then(() => {
                that.setState({ loading: false });
                Notify('success', 'Successfully deleted user');
              })
              .catch(e => {
                that.setState({ loading: false });
                Notify('error', e);
              });
          })
          .catch(e => {
            that.setState({ loading: false });
            Notify('error', e);
          });
      },
      oncancel() {}
    });
  };
  managerForm;
  onAddManager = e => {
    this.setState({ addManagerVisible: true, editManager: undefined });
  };
  handleAddManager = e => {
    e.preventDefault();
    this.managerForm.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.onFinish(values);
        this.setState({ loading: true });
        if (this.state.editManager) {
          values._id = this.state.editManager._id;
        } else {
          values.type = 'manager';
          values.password = 'pass';
          values.firstLogin = true;
        }
        this.props
          .addManager(values)
          .then(() => {
            this.props
              .findAllManagers()
              .then(() => {
                if (this.state.editManager) {
                  Notify('success', 'Successfully saved Staff Member'); // You can replace info() with Notify("success", "Successfully saved user");
                } else {
                  success();
                  // You can replace success() with Notify("success", "Successfully added user");
                }
                this.managerForm.props.form.resetFields();

                this.setState({
                  loading: false,
                  addManagerVisible: false,
                  editManager: undefined
                });
              })
              .catch(e => {
                this.setState({ loading: false });
                Notify('error', e);
              });
          })
          .catch(e => {
            this.setState({ loading: false });
            Notify('error', e);
          });
      }
    });
  };
  handleEditManager = e => {
    this.setState({ addManagerVisible: true, editManager: e });
  };
  handleDeleteManager = e => {
    const id = e.currentTarget.getAttribute('data');
    var that = this;
    Modal.confirm({
      centered: true,
      content: (
        <div>
          <h4>Are your sure you want to delete this user?</h4>
        </div>
      ),
      onOk() {
        that.setState({ loading: true });
        that.props
          .deleteUser(id)
          .then(() => {
            that.props
              .findAllManagers()
              .then(() => {
                that.setState({ loading: false });
                Notify('success', 'Successfully deleted manager');
              })
              .catch(e => {
                that.setState({ loading: false });
                Notify('error', e);
              });
          })
          .catch(e => {
            that.setState({ loading: false });
            Notify('error', e);
          });
      },
      oncancel() {}
    });
  };
  buyerForm;
  onAddBuyer = e => {
    this.setState({ addBuyerVisible: true, editBuyer: undefined });
  };
  handleAddBuyer = e => {
    e.preventDefault();
    this.buyerForm.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        if (!this.state.editBuyer) {
          // Execute only if editUser is false
          // this.onFinish(values); // Call onFinish when not editing user
        }
        this.setState({ loading: true });
        if (this.state.editBuyer) {
          values._id = this.state.editBuyer._id;
        } else {
          values.type = 'buyer';
          values.password = 'pass';
          values.firstLogin = true;
        }
        this.props
          .addBuyer(values)
          .then(() => {
            this.props
              .findAllBuyers()
              .then(() => {
                if (this.state.editBuyer) {
                  Notify('success', 'Successfully saved company user');
                } else {
                  Notify('success', 'Successfully added company user');
                }
                this.buyerForm.props.form.resetFields();
                this.setState({
                  loading: false,
                  addBuyerVisible: false,
                  editBuyer: undefined
                });
              })
              .catch(e => {
                this.setState({ loading: false });
                Notify('error', e);
              });
          })
          .catch(e => {
            this.setState({ loading: false });
            Notify('error', e);
          });
      }
    });
  };
  handleEditBuyer = e => {
    this.setState({ addBuyerVisible: true, editBuyer: e });
  };
  handleDeleteBuyer = e => {
    const id = e.currentTarget.getAttribute('data');
    var that = this;
    Modal.confirm({
      centered: true,
      content: (
        <div>
          <h4>Are your sure you want to delete this user?</h4>
        </div>
      ),
      onOk() {
        that.setState({ loading: true });
        that.props
          .deleteUser(id)
          .then(() => {
            that.props
              .findAllBuyers()
              .then(() => {
                that.setState({ loading: false });
                Notify('success', 'Successfully deleted user');
              })
              .catch(e => {
                that.setState({ loading: false });
                Notify('error', e);
              });
          })
          .catch(e => {
            that.setState({ loading: false });
            Notify('error', e);
          });
      },
      oncancel() {}
    });
  };
  render() {
    const { user } = this.props;

    const sites = this.props.sites || [];
    const users = this.props.users || [];

    const selectedId = this.state.siteSelected
      ? String(this.state.siteSelected)
      : null;

    // logged-in user's allowed sites
    const accessList = (this.props.access || user.access || []).map(id =>
      String(id)
    );

    const selectedSite = selectedId
      ? sites.find(site => String(site._id) === selectedId)
      : null;

    let filteredUsers = users.filter(u => u.active === true);

    if (user.type !== 'admin') {
      // Only show users that have at least one site in common with logged-in user access
      filteredUsers = filteredUsers.filter(u => {
        const uAccess = (u.access || []).map(id => String(id));
        return uAccess.some(id => accessList.includes(id));
      });
    }

    // If a specific site is selected, restrict to users that have that site
    if (selectedId) {
      filteredUsers = filteredUsers.filter(u =>
        (u.access || []).map(id => String(id)).includes(selectedId)
      );
    }

    const props = this.props.collapsed;
    return (
      <div style={{ maxWidth: '90em', margin: 'auto' }}>
        {/* <img
          style={{
            height: props ? '8em' : '13em',
            width: props ? '9.8em' : '16.1em',
            transform: props ? 'scale(0.6)' : 'scale(0.65)',
            position: 'fixed',
            left: props ? '-1.8em' : '0em',
            top: props ? '-1em' : '-1.8em',
            transition: '0.2s',
            objectFit: 'contain'
          }}
          src={
            selectedSite && selectedSite.mainCatImage
              ? selectedSite.mainCatImage.includes('data')
                ? selectedSite.mainCatImage
                : process.env.REACT_APP_GLOBAL_SERVER +
                  'sproutmanagement/api/images/' +
                  selectedSite.mainCatImage
              : null
          }
          // alt="Site"
        /> */}
        <Spin spinning={this.state.loading}>
          <Tabs
            animated={true}
            activeKey={this.state.activeTabKey} // Track the active tab
            onChange={activeKey => this.setState({ activeTabKey: activeKey })} // Update state on tab change
            tabBarExtraContent={
              this.state.activeTabKey === '2' ? (
                <Button
                  style={{ marginBottom: '1em' }}
                  type="primary"
                  onClick={this.onAddUser}
                  icon={<PlusCircleFilled style={{ fontSize: '110%' }} />}
                  size="large"
                >
                  Add User
                </Button>
              ) : this.state.activeTabKey === '3' ? (
                <Button
                  style={{ marginBottom: '1em' }}
                  type="primary"
                  onClick={this.onAddBuyer}
                  icon={<PlusCircleFilled style={{ fontSize: '110%' }} />}
                  size="large"
                >
                  Add Company User
                </Button>
              ) : null // No button for other tabs
            }
            style={{ overflow: 'visible', margin: 'auto' }}
          >
            {/* <Tabs.TabPane tab="User" key="1">
              <Row
                type="flex"
                justify="start"
                align="middle"
                style={{ textAlign: "center", margin: "auto", backgroundColor: "#215273", padding: "0.5em", borderRadius: "1em 1em 0em 0em" }}
              >
                <Col
                  xs={24}
                  md={12}
                  style={{ textAlign: "left" }}
                >
                  <img
                    src={BellIconSVG}
                    style={{ width: "1.6em", marginTop: "-0.7em", marginRight: 7 }}>
                  </img>
                  <span style={{ fontWeight: 750, fontSize: 28, color: "white" }}>User</span>
                </Col>
                <Col
                  style={{ display: "flex", justifyContent: "flex-end" }}
                  xs={24}
                  md={12}
                >
                  <div
                    style={{
                      textAlign: "right",
                      marginTop: 5,
                      marginBottom: 5,
                    }}
                  >
      
                    <Button
                      type="primary"
                      style={{ height: "2em", marginRight: 15, fontSize: "20px", fontWeight: 500, borderRadius: "3em" }}
                      onClick={this.onAddManager}
                    >
                      <PlusOutlined /> Add User
                    </Button>
                  </div>
                </Col>
              </Row>
              <Row type="flex" justify="start" align="middle">
                <Col span={24}>
                  <StyledTable
                    style={{
                      background: "white",

                      margin: "auto",
                    }}
                    rowKey="_id"
                    size="middle"
                    pagination={{
                      defaultPageSize: 50,
                    }}
                    rowClassName={(record, index) => (index % 2 === 1 ? 'highlighted-row' : '')}
                    expandedRowRender={
                      window.innerWidth <= 420
                        ? (record, index, indent, expanded) => (
                          <Card
                            size="small"
                            title={record.name}
                            style={{ width: 300, marginLeft: -35 }}
                          >
                            <p>Number: {record.number}</p>
                            <p>Email: {record.email}</p>
                          </Card>
                        )
                        : null
                    }
                    dataSource={this.props.managers}
                    onChange={this.handleSort}
                  >
                    <Column
                      {...this.getColumnSearchProps("username")}
                      title="Username"
                      dataIndex="username"
                      key="username"
                    />
                    {window.innerWidth > 420 ? (
                      <Column
                        {...this.getColumnSearchProps("name")}
                        title="Name & Surname"
                        dataIndex="name"
                        key="name"
                      />
                    ) : null}

                    {window.innerWidth > 420 ? (
                      <Column
                        {...this.getColumnSearchProps("email")}
                        title="Email"
                        dataIndex="email"
                        key="email"
                      />
                    ) : null}

                    {window.innerWidth > 420 ? (
                      <Column
                        {...this.getColumnSearchProps("access")}
                        title="Company Access"
                        dataIndex="access"
                        key="access"
                        render={(text, record) => {
                          const accessId = Array.isArray(text) ? text[0] : text; // Accessing the string element if text is an array
                          const matchingSite = this.props.sites.find(site => site._id === accessId);
                          return (
                            <span>
                              {matchingSite ? matchingSite.name : "Unknown site"}
                            </span>
                          );
                        }}

                      />
                    ) : null}
                    <Column
                      title="Actions"
                      render={(text, manager) => (
                        <span>
                          <img
                            src={UserEditSVG}
                            style={{ width: "1.6em" }} onClick={e => this.handleEditManager(manager)}>
                          </img>
                          <Divider type="vertical" />
                          <img
                            src={DeleteSVG}
                            style={{ width: "1.6em" }} data={manager._id} onClick={this.handleDeleteManager}>

                          </img>
                        </span>
                      )}
                    />
                  </StyledTable>
                </Col>
              </Row>
            </Tabs.TabPane> */}

            <Tabs.TabPane tab="Users" key="2">
              <Row
                type="flex"
                justify="start"
                align="middle"
                style={{
                  textAlign: 'center',
                  margin: 'auto',

                  padding: '0.5em',
                  paddingTop: '0em',
                  borderRadius: '1em 1em 0em 0em'
                }}
              >
                {/* <Col xs={24} md={12} style={{ textAlign: 'left' }}>
                </Col>
                <Col
                  style={{ display: 'flex', justifyContent: 'flex-end' }}
                  xs={24}
                  md={12}
                >
                  <div
                    style={{
                      textAlign: 'right',
                      marginTop: 5,
                      marginBottom: 5
                    }}
                  >
                    <Button

                      type="primary"
                      onClick={this.onAddUser}
                      icon={<PlusCircleFilled style={{ fontSize: '110%' }} />}
                      size="large"
                      style={
                        {
                          // marginBottom: '1em',
                        }
                      }
                    >
                      Add User
                    </Button>
                  </div>
                </Col> */}
              </Row>
              <Row type="flex" justify="start" align="middle">
                <Col span={24}>
                  <StyledTable
                    style={{
                      background: 'white',

                      margin: 'auto'
                    }}
                    rowKey="_id"
                    size="middle"
                    pagination={{
                      defaultPageSize: 50
                    }}
                    expandedRowRender={
                      window.innerWidth <= 420
                        ? (record, index, indent, expanded) => (
                            <Card
                              size="small"
                              title={record.name}
                              style={{ width: 300, marginLeft: -35 }}
                            >
                              <p>Number: {record.number}</p>
                              <p>Email: {record.email}</p>
                            </Card>
                          )
                        : null
                    }
                    rowClassName={(record, index) =>
                      index % 2 === 1 ? 'highlighted-row' : ''
                    }
                    dataSource={filteredUsers}
                    onChange={this.handleSort}
                  >
                    <Column
                      {...this.getColumnSearchProps('username')}
                      title="Username"
                      dataIndex="username"
                      key="username"
                    />
                    {window.innerWidth > 420 ? (
                      <Column
                        // {...this.getColumnSearchProps('name')}
                        title="Name & Surname"
                        dataIndex="name"
                        key="name"
                      />
                    ) : null}

                    {window.innerWidth > 420 ? (
                      <Column
                        // {...this.getColumnSearchProps('email')}
                        title="Email"
                        dataIndex="email"
                        key="email"
                      />
                    ) : null}
                    {/* {window.innerWidth > 420 ? (
                      <Column
                        {...this.getColumnSearchProps("department")}
                        title="Department"
                        dataIndex="department"
                        key="department"
                      />
                    ) : null} */}
                    {window.innerWidth > 420 ? (
                      <Column
                        // {...this.getColumnSearchProps('access')}
                        title="Company Access"
                        dataIndex="access"
                        key="access"
                        render={(text, record) => {
                          const accessId = Array.isArray(text) ? text[0] : text; // Accessing the string element if text is an array
                          const matchingSite = this.props.sites.find(
                            site => site._id === accessId
                          );
                          return (
                            <span>
                              {matchingSite
                                ? matchingSite.name
                                : 'Unknown site'}
                            </span>
                          );
                        }}
                      />
                    ) : null}
                    <Column
                      title="Actions"
                      render={(text, user) => (
                        <span>
                          <EditFilled
                            style={{
                              backgroundColor: '#80CE90',
                              color: 'white',
                              padding: '0.5em',
                              borderRadius: '3em'
                            }}
                            onClick={e => this.handleEditUser(user)}
                          />

                          <Divider type="vertical" />
                          <DeleteFilled
                            style={{
                              backgroundColor: 'crimson',
                              color: 'white',
                              padding: '0.5em',
                              borderRadius: '3em'
                            }}
                            data={user._id}
                            onClick={this.handleDeleteUser}
                          />
                        </span>
                      )}
                    />
                  </StyledTable>
                </Col>
              </Row>
            </Tabs.TabPane>
            {/* <TabPane tab="Company Management" key="3">
              <Row
                type="flex"
                justify="start"
                align="middle"
                style={{
                  textAlign: 'center',
                  margin: 'auto',

                  padding: '0.5em',
                  paddingTop: '0em',
                  borderRadius: '1em 1em 0em 0em'
                }}
              >

              </Row>
              <Row type="flex" justify="start" align="middle">
                <Col span={24}>
                  <StyledTable
                    style={{ background: 'white' }}
                    rowKey="_id"
                    size="middle"
                    pagination={{
                      defaultPageSize: 50
                    }}
                    dataSource={this.props.buyers}
                    onChange={this.handleSort}
                  >
                    <Column
                      // {...this.getColumnSearchProps('username')}
                      title="Username"
                      dataIndex="username"
                      key="username"
                    />
                    <Column
                      // {...this.getColumnSearchProps('name')}
                      title="Name & Surname"
                      dataIndex="name"
                      key="name"
                    />

                    <Column
                      // {...this.getColumnSearchProps('email')}
                      title="Email"
                      dataIndex="email"
                      key="email"
                    />
                    {window.innerWidth > 420 ? (
                      <Column
                        // {...this.getColumnSearchProps('access')}
                        title="Company Access"
                        dataIndex="access"
                        key="access"
                        render={(text, record) => {
                          const accessId = Array.isArray(text) ? text[0] : text; // Accessing the string element if text is an array
                          const matchingSite = this.props.sites.find(
                            site => site._id === accessId
                          );
                          return (
                            <span>
                              {matchingSite
                                ? matchingSite.name
                                : 'Unknown site'}
                            </span>
                          );
                        }}
                      />
                    ) : null}
                    <Column
                      title="Actions"
                      render={(text, buyer) => (

                        <span>
                          <EditFilled
                            style={{
                              backgroundColor: '#80CE90',
                              color: 'white',
                              padding: '0.5em',
                              borderRadius: '3em'
                            }}
                            onClick={e => this.handleEditBuyer(buyer)}
                          />

                          <Divider type="vertical" />
                          <DeleteFilled
                            style={{
                              backgroundColor: 'crimson',
                              color: 'white',
                              padding: '0.5em',
                              borderRadius: '3em'
                            }}
                            data={buyer._id}
                            onClick={this.handleDeleteBuyer}
                          />
                        </span>
                      )}
                    />
                  </StyledTable>
                </Col>
              </Row>
            </TabPane> */}
          </Tabs>
        </Spin>
        {this.state.addUserVisible ? (
          <Modal
            title="Add User"
            visible={this.state.addUserVisible}
            onOk={this.handleAddUser}
            onCancel={e => this.setState({ addUserVisible: false })}
            okText={this.state.editUser ? 'Save' : 'Add User'}
            cancelText="Cancel"
          >
            <UserForm
              managers={this.props.managers}
              editUser={this.state.editUser}
              sites={this.props.sites}
              access={this.props.user.access}
              wrappedComponentRef={form => (this.userForm = form)}
            />
          </Modal>
        ) : null}
        <Modal
          title="Add User"
          visible={this.state.addManagerVisible}
          onOk={this.handleAddManager}
          onCancel={e => this.setState({ addManagerVisible: false })}
          okText={this.state.editManager ? 'Save' : 'Add User'}
          cancelText="Cancel"
        >
          <ManagerForm
            editManager={this.state.editManager}
            sites={this.props.sites}
            wrappedComponentRef={form => (this.managerForm = form)}
          />
        </Modal>
        <Modal
          title="Add Company User"
          visible={this.state.addBuyerVisible}
          onOk={this.handleAddBuyer}
          onCancel={e => this.setState({ addBuyerVisible: false })}
          okText={this.state.editBuyer ? 'Save' : 'Add User'}
          cancelText="Cancel"
        >
          <BuyerForm
            editBuyer={this.state.editBuyer}
            sites={this.props.sites}
            wrappedComponentRef={form => (this.buyerForm = form)}
          />
        </Modal>
      </div>
    );
  }
}

const WrappedUsers = Form.create()(Users);
const mapStateToProps = state => {
  return {
    collapsed: getSidebarCollapsed(state)
  };
};
const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WrappedUsers);
